import type { Params } from '../../shared/types';

export const addParams = (url: string, params?: Params): string => {
  if (!params) {
    return url;
  }
  const query = Object.keys(params)
    .filter(
      (k) => params[k] !== undefined && params[k] !== '' && params[k] !== null
    )
    .map(
      (k) =>
        encodeURIComponent(k) +
        '=' +
        // prevent undefined and null from becoming their string names
        (['undefined', 'object'].includes(typeof params[k])
          ? ''
          : encodeURIComponent(params[k] as string | number | boolean))
    )
    .join('&');

  return `${url}${url.indexOf('?') === -1 ? '?' : '&'}${query}`;
};

export default addParams;
